import isEmpty from 'lodash/isEmpty'

import { User_user } from 'main/gql/user'
import {
  initialParams as initialChildParams,
  validate as validateChildParams,
} from './ChildSection'
import {
  initialParams as initialPasswordParams,
  validate as validatePasswordParams,
} from './PasswordSection'
import { IParams, IValidation } from './types'

export function initialParams(): IParams {
  return {
    ...initialPasswordParams(),
    child: initialChildParams(),
  }
}

export function validate(params: IParams): IValidation {
  const { child, password } = params
  const validation: IValidation = {}

  const passwordValidation = validatePasswordParams({ password })
  if (passwordValidation.password) {
    validation.password = passwordValidation.password
  }

  const childValidation = validateChildParams(child)
  if (!isEmpty(childValidation)) {
    validation.child = childValidation
  }

  return validation
}

export function isChildSectionRequired(user: User_user) {
  const {
    family: { children },
  } = user

  return !children.length
}

export function isPasswordSectionRequired(user: User_user) {
  const { hasPassword } = user

  return !hasPassword
}

export function isFormRequired(user: User_user) {
  return isChildSectionRequired(user) || isPasswordSectionRequired(user)
}
